import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ user, onLogout }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    onLogout();
  };

  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="navbar-logo">
          <div className="logo-icon">🚛</div>
          <span className="navbar-brand">Vehicle Tracking</span>
        </div>
      </div>

      <div className="navbar-right">
        <div className="notification-icon">
          <span>🔔</span>
          <span className="notification-badge">3</span>
        </div>

        <div 
          className="user-info"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <div className="user-avatar">
            {getInitials(user?.full_name || user?.username || 'U')}
          </div>
          <div className="user-details">
            <span className="user-name">{user?.full_name || user?.username}</span>
            <span className="user-role">{user?.role?.toUpperCase()}</span>
          </div>
          <span className="dropdown-arrow">▼</span>

          {showDropdown && (
            <div className="user-dropdown">
              <div className="dropdown-item">
                <span>👤</span>
                <span>Profile</span>
              </div>
              <div className="dropdown-item">
                <span>⚙️</span>
                <span>Settings</span>
              </div>
              <div className="dropdown-divider"></div>
              <div 
                className="dropdown-item logout"
                onClick={handleLogout}
              >
                <span>🚪</span>
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
